import React from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import Select from "react-select";
import { RESET_FILTERS } from "../../reducers/reducersFilters/filters";
import { SET_RESCHEDULE_LINE_UUID } from "../../reducers/common";
import { translate } from "../../../../IntlProviderWrapper";

import type { SetRescheduleLineAction } from "../../reducers/common";
import type { ResetFiltersAction } from "../../reducers/reducersFilters/filters";
import type { SelectOptionItem } from "./TypeFilterConsts";
import type { ReduxState } from "../../reducers/reducers";

type ActionTypes = SetRescheduleLineAction | ResetFiltersAction;
type OwnProps = {};
type Props = OwnProps & ReduxProps;

class RescheduleLineFilter extends React.Component<Props> {
    onChange = async (option: SelectOptionItem) => {
        if (!option) {
            this.props.reduxDispatch({ type: RESET_FILTERS, data: undefined });
        } else {
            this.props.reduxDispatch({ type: SET_RESCHEDULE_LINE_UUID, data: option.value });
        }
    };

    getSelectedOptions = (): SelectOptionItem | null => {
        if (!this.props.reschedule_line_uuid) {
            return null;
        }
        for (const line_order of this.props.lines_orders) {
            if (line_order.line_uuid === this.props.reschedule_line_uuid) {
                return {
                    value: line_order.line_uuid,
                    label: line_order.line_title,
                };
            }
        }
        return null;
    };

    getOptions = (): SelectOptionItem[] => {
        const options: SelectOptionItem[] = [];
        for (const line_order of this.props.lines_orders) {
            options.push({
                value: line_order.line_uuid,
                label: line_order.line_title,
            });
        }
        return options;
    };

    render() {
        return (
            <div className="order-filter">
                <Select
                    value={this.getSelectedOptions()}
                    placeholder={translate("common.reschedule_line", "Reschedule line")}
                    options={this.getOptions()}
                    onChange={this.onChange}
                    isSearchable={true}
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 100 }),
                        menu: base => ({ ...base, width: "max-content", minWidth: "100%" }),
                    }}
                />
            </div>
        );
    }
}

const mapState = (state: ReduxState) => {
    const filters = state.gantt_chart_filters;
    const lines_orders = state.gantt_chart_lines_orders.lines_orders;
    const report = state.gantt_chart_report;
    return {
        reschedule_line_uuid: filters.reschedule_line_uuid,
        lines_orders,
        original_report_created_at: report.original_report_created_at,
    };
};
const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({
    reduxDispatch: dispatch,
});

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(RescheduleLineFilter);
